export default __webpack_public_path__ + "static/gameAlice-f729b4e1da2e60209579af2158ec2e85.png";